export const handleSwitchState = fn => fn(ps => !ps)

export const handleTextInputChange = fn => e => fn(e.target.value)

export const truncate = (str, n) => str.length < n ? str : str.slice(0, n) + "..."

export const unfocus = () => {
  const tmp = document.createElement("input")
  tmp.style.position = "fixed"
  tmp.style.top = "50%"
	document.body.appendChild(tmp)
	tmp.focus()
  document.body.removeChild(tmp)
}